import { METALNORD_USERS } from "../metalnord/access.mjs";

export default {
    title: "Staff",
    icon: "mdi-chair-rolling",
    groups: ["Amministrazione"],
    submenu: [
        {
            title: "Metalnord",
            route: { name: "staff-metalnord" },
            users: METALNORD_USERS,
            groups: ["Amministrazione"],
        },
        {
            title: "Catalogo KPI",
            route: { name: "staff-kpi-catalog" },
            admin: true,
            groups: [],
        },
        {
            title: "Gestione notifiche",
            route: { name: "GestioneNotifiche" },
            groups: ["Amministrazione"],
        },
        {
            title: "Controllo Prezzi",
            route: { name: "staff-prezzi" },
            groups: ["Amministrazione"],
        },
        {
            title: "Controllo Odv",
            route: { name: "staff-controllodv" },
            groups: ["Amministrazione"],
        },
        {
            title: "Budget Previsionale",
            route: { name: "staff-budgetprevisionale" },
            groups: ["Amministrazione"],
        },
        {
            title: "Manutenzioni",
            route: { name: "staff-manutenzioni" },
            groups: ["Amministrazione"],
        },
        {
            title: "Parametri fasi",
            route: { name: "staff-parametri-fasi" },
            groups: ["Amministrazione"],
        },
        {
            title: "Parser ordini",
            route: { name: "staff-parser-ordini" },
            groups: ["Amministrazione"],
        },
        {
            title: "Fix Storico",
            route: { name: "staff-fixstorico" },
            groups: ["Amministrazione"],
        },
        {
            title: "Prelievi materiale Oseon",
            route: { name: "laser-prelievi-materiale" },
            icon: "mdi-scale-balance",
            groups: ["Tecnici", "Laser", "Schedulazione", "Amministrazione"],
        },
    ],
};
